import { UserContext, UserContextType } from '@/shared/contexts/User';
import { isNull } from 'lodash';
import { useContext } from 'react';

type Props = {};

const useUserContext = () : UserContextType => {
    const contextValue = useContext(UserContext);

    if (isNull(UserContext)) {
        throw new Error('User context is not set.');
    }

    return contextValue.user;
};

export const useUserContextLoading = () : boolean => {
    return useContext(UserContext).isLoading;
};

export default useUserContext;
